import { render } from "./eb-thumbnail-card-skeleton.vue?vue&type=template&id=6b0d3fc2"
import script from "./eb-thumbnail-card-skeleton.vue?vue&type=script&lang=ts"
export * from "./eb-thumbnail-card-skeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script